import React from "react";
import { Link } from "react-router-dom";

class BottomBar extends React.Component {
  render() {
    const chatSupport =
      this.props.chatSupport !== undefined && this.props.chatSupport !== null
        ? String(this.props.chatSupport)
        : String(localStorage.getItem("chat_support") || "0");

    const chatCode =
      this.props.chatCode !== undefined && this.props.chatCode !== null
        ? this.props.chatCode
        : localStorage.getItem("chat_code") || "";

    const whatsappUrl =
      this.props.whatsappUrl ||
      (localStorage.getItem("whatsapp")
        ? "https://wa.me/+91" + localStorage.getItem("whatsapp")
        : "");

    const onHomeClick =
      this.props.onHomeClick || (() => (window.location.href = "/home"));

    return (
      <div
        className="colored"
        style={{
          padding: "0",
          position: "fixed",
          bottom: "0",
          width: "100%",
          backgroundColor: "var(--button-background)",
        }}
      >
        <div style={{ marginBottom: "2px" }}>
          <div
            className="row row-cols-5 homemenu"
            style={{ margin: "0", paddingTop: "4px" }}
          >
            <div className="col">
              <Link to={"/gameHistory"}>
                <div className="homediv">
                  <img
                    src="../images/bidhs.png"
                    style={{ padding: "5px", filter: "invert(1)" }}
                  />
                  <span style={{ color: "white" }}>My Bids</span>
                </div>
              </Link>
            </div>
            <div className="col">
              <Link to={"/transactions"}>
                <div className="homediv">
                  <img
                    src="../images/passhs.png"
                    style={{ padding: "5px", filter: "invert(1)" }}
                  />
                  <span style={{ color: "white" }}>Passbook</span>
                </div>
              </Link>
            </div>

            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div onClick={onHomeClick}>
                <div className="homediv">
                  <img
                    src="../images/home_flat.png"
                    style={{
                      padding: "5px",
                      filter: "invert(1)",
                      height: "43px",
                      width: "43px",
                      margin: "0",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="col">
              <Link to={"/withdraw"}>
                <div className="homediv">
                  <img
                    src="../images/wallet_deduct.png"
                    style={{ padding: "5px", filter: "invert(1)" }}
                  />
                  <span style={{ color: "white" }}>Withdraw</span>
                </div>
              </Link>
            </div>

            {chatSupport === "0" ? (
              <div className="col">
                <a href={whatsappUrl}>
                  <div className="homediv">
                    <img
                      src="../images/chaths.png"
                      style={{ padding: "5px", filter: "invert(1)" }}
                    />
                    <span style={{ color: "white" }}>Whatsapp</span>
                  </div>
                </a>
              </div>
            ) : (
              <div className="col">
                <Link style={{ width: "100%" }} to={"/liveChat"} state={{ url: chatCode }}>
                  <div className="homediv">
                    <img src="../images/chaths.png" style={{ padding: "5px" }} />
                    <span>Chat</span>
                  </div>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default BottomBar;
